import React from 'react'
import classes from './StartPage.module.scss'
import PageCard from './PageCard/PageCard'
import { pages } from '../../App'

const StartPage = (): JSX.Element => (
  <div className={classes.root}>
    <div className={classes.info}>
      <h1>Välkommen!</h1>
      <p>
        Varje år sammanställer vi statistik över hur mycket som pantas i Sverige
        och därmed kan återvinnas till nya burkar och flaskor.
      </p>
      <p>
        Den totala insamling av sålda förpackningar för 2025 är
        <strong> 88,4 procent</strong>, vilket är en ökning med 0,8
        procentenheter jämfört med föregående år. 2025 är ett rekordår, då vi
        tog emot över 3 miljarder pantade förpackningar i vår anläggning.
      </p>
    </div>
    <div className={`row ${classes.cards}`}>
      {pages.map((section) => (
        <div className="col-xs-12 col-sm-6 col-lg-4" key={section.route}>
          <PageCard
            title={section.menuLabel}
            routeLink={section.route}
            icon={section.cardIcon}
            contentText={section.description}
          />
        </div>
      ))}
    </div>
  </div>
)

export default StartPage
